export default {
  dashboards: {
    en: {
      title: 'My dashboards'
    },
    ru: {
      title: 'Мои dashboards'
    }
  },
  edit_dashboard: {
    en: {
      title: 'Edit dashboard'
    },
    ru: {
      title: 'Редактировать dashboard'
    }
  },
  add_dashboard: {
    en: {
      title: 'Add dashboard'
    },
    ru: {
      title: 'Добавить dashboard'
    }
  },
  servers: {
    en: {
      title: 'Servers'
    },
    ru: {
      title: 'Серверы'
    }
  },
  user_settings: {
    en: {
      title: 'User'
    },
    ru: {
      title: 'Пользователь'
    }
  },
  system_settings: {
    en: {
      title: 'System'
    },
    ru: {
      title: 'Система'
    }
  },
  sources: {
    en: {
      title: 'Sources'
    },
    ru: {
      title: 'Источники'
    }
  },
  models: {
    en: {
      title: 'Loaded models'
    },
    ru: {
      title: 'Загруженные модели'
    }
  },
  outputs: {
    en: {
      title: 'Outputs'
    },
    ru: {
      title: 'Выходы'
    }
  },
  add_output: {
    en: {
      title: 'Add output'
    },
    ru: {
      title: 'Добавить выход'
    }
  },
  pipelines: {
    en: {
      title: 'Process configurations'
    },
    ru: {
      title: 'Пайплайны'
    }
  },
  pipeline: {
    en: {
      title: 'Pipeline'
    },
    ru: {
      title: 'Пайплайн'
    }
  },
  mergers: {
    en: {
      title: 'Merge configurations'
    }
  },
  merge: {
    en: {
      title: 'Merge'
    }
  },
  add_pipeline: {
    en: {
      title: 'Add Pipeline'
    },
    ru: {
      title: 'Добавить пайплайн'
    }
  },
  source: {
    en: {
      title: 'Source'
    },
    ru: {
      title: 'Источник'
    }
  },
  add_source: {
    en: {
      title: 'Add Source'
    },
    ru: {
      title: 'Добавить источник'
    }
  },
  add_server: {
    en: {
      title: 'Add Server'
    },
    ru: {
      title: 'Добавить сервер'
    }
  },
  edit_source: {
    en: {
      title: 'Edit Source'
    },
    ru: {
      title: 'Редактировать источник'
    }
  },
  reports: {
    en: {
      title: 'Reports'
    },
    ru: {
      title: 'Отчеты'
    }
  },
  server: {
    en: {
      title: 'Server'
    },
    ru: {
      title: 'Сервер'
    }
  },
  lists: {
    en: {
      title: 'Lists'
    },
    ru: {
      title: 'Списки'
    }
  },
  list: {
    en: {
      title: 'List'
    },
    ru: {
      title: 'Список'
    }
  },
  add_list: {
    en: {
      title: 'Add List'
    },
    ru: {
      title: 'Добавить список'
    }
  },
  list_items: {
    en: {
      title: 'List Items'
    },
    ru: {
      title: 'Список элементов'
    }
  },
  ui_settings: {
    en: {
      title: 'User interface elements'
    },
    ru: {
      title: 'Элементы пользовательского интерфейса'
    }
  },
  add_ui_element: {
    en: {
      title: 'Add user interface element'
    },
    ru: {
      title: 'Добавить элемент пользовательского интерфейса'
    }
  },
  ui_element: {
    en: {
      title: 'User interface element'
    },
    ru: {
      title: 'Элемент пользовательского интерфейса'
    }
  }
}
